import React, { useState } from 'react'

import classNames from 'classnames/bind'

import classes from './Video.module.scss'

const cx = classNames.bind(classes)

export const Video: React.FC = () => {
  const [isVideoShowed, setVideoShowed] = useState(false)
  const containerClasses = cx('row', 'video__container', {
    video_showed: isVideoShowed,
  })

  return (
    <div className={containerClasses}>
      <div className="col-xs-12">
        <div className={classes.video__wrapper}>
          <div className={classes.bg} />
          <button
            className={classes.btn}
            onClick={() => setVideoShowed(true)}
          />
          <iframe
            className={classes.video}
            title="yt-frame"
            allowFullScreen
            frameBorder="0"
            src="https://www.youtube.com/embed/4YR5mpjlApQ"
          />
        </div>
      </div>
    </div>
  )
}
